import http from '@/vendor/axios'

export function getOkrListIdByCycle (cycleId, userId) {
  const url = '/object/okr.okrlist/current_cycle'
  return http.post(url, {
    params: {
      kwargs: {
        cycle_id: cycleId,
        user_id: userId,
        fields: ['id']
      }
    }
  })
}

export function createObjective (objective) {
  const url = '/api/okr.objective'
  return http.post(url, {
    params: {
      data: objective
    }
  })
}

export function updateObjective (objectiveId, objective) {
  const url = `/api/okr.objective/${objectiveId}`

  return http.put(url, {
    params: {
      data: objective
    }
  })
}

export function createKeyResult (objectiveId, keyResult) {
  const url = '/api/okr.keyresult'

  return http.post(url, {
    params: {
      data: {
        objective_id: objectiveId,
        ...keyResult
      }
    }
  })
}

export function updateKeyResult (keyResultId, keyResult) {
  const url = `/api/okr.keyresult/${keyResultId}/`

  return http.put(url, {
    params: {
      data: keyResult
    }
  })
}

export function deleteObjective (id) {
  const url = `/object/okr.objective/${id}/archive`

  return http.post(url, {
    params: {}
  })
}

export function deleteKeyResult (id) {
  const url = `/object/okr.keyresult/${id}/archive`

  return http.post(url, {
    params: {}
  })
}

export function publish (okrListId, doesNotify) {
  const url = `/object/okr.okrlist/${okrListId}/approval`

  return http.post(url, {
    params: {
      kwargs: {
        is_notice: doesNotify
      }
    }
  })
}

export function andyPublish (okrListId, doesNotify) {
  const url = `/object/okr.okrlist/${okrListId}/publish`
  return http.post(url, {
    params: {
      kwargs: {
        is_notice: doesNotify
      }
    }
  })
}

/**
 * 对齐
 *
 * @param {number} id - 要对齐的实体 statementId
 * @param {number} aligningId - 被对齐的实体 statementId
 * @returns {Promise<Object>}
 */
export function align (id, aligningId) {
  const url = `/api/okr.statement/${id}`

  return http.put(url, {
    params: {
      data: {
        link_to_statements: {
          push: [aligningId]
        }
      }
    }
  })
}

/**
 * 取消对齐
 *
 * @param {number} id - 要取消对齐的实体 statementId
 * @param {number} unaligningId - 被取消对齐的实体 statementId
 * @returns {Promise<Object>}
 */
export function unalign (id, unaligningId) {
  const url = `/api/okr.statement/${id}`

  return http.put(url, {
    params: {
      data: {
        link_to_statements: {
          pop: [unaligningId]
        }
      }
    }
  })
}

export function updateReview (objectiveId, review) {
  const url = `/api/okr.objective/${objectiveId}`

  return http.put(url, {
    params: {
      data: review
    }
  })
}

export function newUpdateReview (reviewId, review) {
  const url = `/api/okr.objective.review/${reviewId}`
  return http.put(url, {
    params: {
      data: review
    }
  })
}

export function createReview (objectiveId, review) {
  const url = '/api/okr.objective.review'
  return http.post(url, {
    params: {
      data: review
    }
  })
}

export function updateOverallReview (reviewId, review) {
  const url = `/api/okr.okrlist.review/${reviewId}`
  return http.put(url, {
    params: {
      data: review
    }
  })
}

export function createOverallReview (review) {
  const url = '/api/okr.okrlist.review'
  return http.post(url, {
    params: {
      data: review
    }
  })
}

export function getOverallReviews (id) {
  const url = `/api/okr.okrlist/${id}`
  return http.get(url, {
    params: {
      query: '{id,overall_reviews{id,review_content,review_attachments,review_flag}}'
    }
  })
}

export function getOkrListReviews (id) {
  const url = '/api/mail.message'

  return http.get(url, {
    params: {
      query: '{id,body,okrlist_id,create_date,create_uid{id,nickname,avatar_url,name},attachment_ids{id,mimetype,name}}',
      filter: `[["subtype_id", "=","mt_okr_comment"],["okrlist_id", "=", ${id}]]`,
      limit: 99999,
      order: '"id asc"',
      ts: Date.now()
    }
  }).then(res => res.result)
}

// 更新组织能力或者个人发展
export function updatePersonalObjective (okrListId, data) {
  const url = `/api/okr.okrlist/${okrListId}`
  return http.put(url, {
    params: {
      data: data
    }
  })
}
